import React, { useEffect, useRef } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, FormControl, Grid, InputLabel, Stack, Switch, Typography, useTheme } from '@mui/material';
import { useMediaPredicate } from 'react-media-hook';
import { useTranslation } from 'react-i18next';
import withLoading, { WithLoadingProps } from '../../../Shared/Loader';
import { DeleteImagesBuildingRequest, ImageCategoryDTO, ImageDiaryDTO, RequestsDTO, VovClient } from '../../../../ApiOld/ApiServerVov';
import { APIVovHelper } from '../../../../ApiOld/ApiOldClient';
import { useBuildingsPermissionContext } from '../../../../Contexts/Permissions/BuildingsPermissionContext';
import { useApi } from '../../../../ApiOld/Api/useApi';
import ProjectPhotosCategoryScene from './ProjectPhotosCategoryScene';
import ProjectPhotosDetailScene from './ProjectPhotosDetailScene';
import CreateRequestFromImageBuildingDialog from '../Dialogs/CreateRequestFromImageBuildingDialog';
import PhotosDateCategorizer from './Photos/PhotosDateCategorizer';
import { BuildingVovClient } from '../../../../ApiOld/Api/ApiServerVov';
import { Add, ArrowLeft, ArrowRight } from '@mui/icons-material';

interface ProjectPhotosSceneProps extends WithLoadingProps {
    buildingId: number,
    buildingName: string
}
function ProjectPhotosScene(props: ProjectPhotosSceneProps) {
    const { buildingId, buildingName, fireLoading, stopLoading } = props;
    const [images, setImages] = React.useState<ImageDiaryDTO[]>([]);
    const [categories, setCategories] = React.useState<ImageCategoryDTO[]>([]);
    const [selectedCategory, setSelectedCategory] = React.useState<ImageCategoryDTO | null>();
    const [recordId, setRecordId] = React.useState<number | undefined>(undefined);

    const [photoWide, setPhotoWide] = React.useState<boolean>(true);

    const [loading, setLoading] = React.useState<boolean>(false);
    const biggerThan700 = useMediaPredicate("(min-width: 1100px)");
    const { t, i18n } = useTranslation();
    const { authorizedApi } = useApi(BuildingVovClient);

    const { permissions, reloadPermissions } = useBuildingsPermissionContext();

    useEffect(() => {
        if (!permissions)
            reloadPermissions();
    }, [reloadPermissions]);

    useEffect(() => {
        refreshImages()
    }, []);

    useEffect(() => {
        refreshImages();
    }, [buildingId]);

    function setDefaultState() {
        if (buildingId !== undefined)
            setRecordId(buildingId);
        setImages([]);
    }
    function refreshImages() {
        setDefaultState();
        //fireLoading!();
        setLoading(true);
        authorizedApi.getImagesBuilding(buildingId === undefined ? 0 : buildingId).then((data) => {
            console.log(data);
            if (data)
                setImages(data.images!);

            setCategories([new ImageCategoryDTO({ name: t('buildings.notAssignedPhotos'), id: undefined }), ...data.categories!]);
            stopLoading!();
            setLoading(false);

        }).catch(() => { stopLoading!(); console.log('err'); setLoading(false); });
    }

    const getCanDelete = (): boolean => {
        if (!permissions) return false;
        return permissions.buildingsEdit!;
    }

    const [todoImage, setTodoImage] = React.useState<ImageDiaryDTO | undefined>(undefined);
    const [showDates, setShowDates] = React.useState<boolean>(false);
    const [selectedDateImage, setSelectedDateImage] = React.useState<ImageDiaryDTO | undefined>(undefined);
    return (
        <div style={{ maxWidth: biggerThan700 ? '100%' : '600px', margin: '12px', marginTop: '16px', }}>
            <Grid container spacing={3}>
                <Grid item lg={photoWide ? 4 : 2} xs={12}>
                    <Box
                        sx={{
                            border: '1px solid rgba(0, 0, 0, 0.23)',
                            borderRadius: '10px',
                            padding: '22px',
                            position: 'relative',
                            mt: 2
                        }}
                    >
                        <Box
                            sx={{
                                position: 'absolute',
                                right: '0px',
                                top: '50%',
                                transform: 'translateY(-50%)'
                            }}
                        >
                            <Button
                                variant="contained"
                                size="small"
                                sx={{
                                    backgroundColor: '#FFC600',
                                    color: 'black',
                                    minWidth: '12px',
                                    width: '30px',
                                    height: '40px',
                                    borderRadius: '20px 0 0 20px',
                                    paddingLeft: '8px',
                                    paddingRight: '6px',
                                    '&:hover': {
                                        backgroundColor: '#e3b000'
                                    }
                                }}
                                onClick={() => {
                                    setPhotoWide(!photoWide);
                                }}
                            >
                                {photoWide && <ArrowLeft fontSize="medium" />}
                                {!photoWide && <ArrowRight fontSize="medium" />}
                            </Button>
                        </Box>
                        {/* <Typography
                            variant="caption"
                            sx={{
                                position: 'absolute',
                                top: '-10px',
                                left: '10px',
                                padding: '0 5px',
                                backgroundColor: (theme) => theme.palette.background.paper,
                                zIndex: 1,
                            }}
                        >
                            {t('buildings.photos')} 
                        </Typography> */}

                        <Stack direction="row" spacing={1} alignItems={'center'} sx={{
                            position: 'absolute',
                            top: '-20px',
                            left: '20px',
                            padding: '0 5px',
                            backgroundColor: (theme) => theme.palette.background.paper
                        }}>
                            <Typography sx={{ fontWeight: !showDates ? 'bold' : 'normal' }}>{t('buildings.folders')}</Typography>
                            <Switch checked={showDates} onChange={(e, ch) => { setShowDates(ch) }} />
                            <Typography sx={{ fontWeight: showDates ? 'bold' : 'normal' }}>{t('dates')}</Typography>
                        </Stack>
                        {showDates && <Box mt={2}><PhotosDateCategorizer
                            imageClicked={(image) => { setSelectedDateImage(image) }}
                            buildingId={buildingId}
                            onImageDateChanged={(imageId, newDate, imageUrl) => {
                                setImages(p => p.map(x => x.id === Number(imageId) ? new ImageDiaryDTO({ ...x, created: newDate }) : x));
                            }}
                            images={images} /></Box>}
                        {!showDates && <ProjectPhotosCategoryScene buildingName={buildingName} buildingId={buildingId} onSelect={(data) => { setSelectedCategory(data); }} categories={categories} onRefresh={() => refreshImages()} />}
                    </Box>
                </Grid>
                <Grid item lg={photoWide ? 8 : 10} xs={12}>
                    <ProjectPhotosDetailScene
                        externalImageOpen={selectedDateImage}
                        categories={categories} loading={loading} setLoading={setLoading} category={selectedCategory ? selectedCategory : undefined} images={images} buildingId={buildingId!} onSelect={() => { }} setImages={setImages} onNewRequest={(image) => {
                            setTodoImage(image);
                        }} onRefresh={() => refreshImages()} />
                </Grid>
            </Grid>


            {todoImage && <CreateRequestFromImageBuildingDialog imageUrl={todoImage.url}
                selectedBuildingId={buildingId} onRefresh={() => { }}
                todo={new RequestsDTO()} open={todoImage !== undefined} selectedValue={t('singleTodo.newTask')} onClose={() => { setTodoImage(undefined) }} />}
        </div>
    );
}
export default withLoading(ProjectPhotosScene);